import React, { useState, useEffect } from 'react'
import { Query, Mutation } from 'react-apollo'
import _ from 'lodash'
import {
  Div, Loading, P, Button as KSButton, H4,
} from 'konsys-ui'
import {
  Modal, message, Input as AntInput, Upload, DatePicker, Checkbox,
} from 'antd'
import { CREATE_REPAIR_JOB, UPDATE_REPAIR_JOB, CLOSE_JOB } from '../../../constants/graphql/mutation'
import {
  GET_REPAIR_JOB_INFO, GET_TRUCK_LIST, DRIVER_LIST, GET_TRUCK_LIST_IN_REPAIR_SERVICE,
} from '../../../constants/graphql/query'
import detailType from '../util-functions'
import { detailMode, repairJobType } from '../constants'
import {
  ActionBar, FuelOrderRepairJob, Wrapper, EditFuelModal,
} from '../../../components/repair-job-components'
import Service from './repair-service'
import PERMISSION from '../../../constants/permissions'
import { UploadWithModal } from '../../../components/common'

const Index = ({ props }) => {
  const isAddMode = props.match.params.mode.toUpperCase() === detailMode.ADD
  const isViewMode = props.match.params.mode.toUpperCase() === detailMode.VIEW
  const [driverSearch, setDriverSearch] = useState('')
  const [driverSelected, setDriverSelected] = useState({})
  const [platenumberSearch, setPlatenumberSearch] = useState('')
  const [truckSelected, setTruckSelected] = useState({})
  const [closeJobVariables, setCloseJobVariables] = useState({})
  const [closeJobModal, setCloseJobModal] = useState(false)
  const [garageSearch, setGarageSearch] = useState('')
  const [garageSelected, setGarageSelected] = useState({})
  const [mutationVariables, setMutationVariables] = useState(isAddMode ? { isRepairTruck: true } : {})
  const [phoneNumber, setPhoneNumber] = useState()
  const [trailerPlatenumberSearch, setTrailerPlatenumberSearch] = useState('')
  const [trailerSelected, setTrailerSelected] = useState({})
  const [trailers, setTrailers] = useState([])
  const [disableTrailer, setDisableTrailer] = useState(true)
  const [editFuelModal, setEditFuelModal] = useState(false)
  const [fuelOrder, setFuelOrder] = useState()
  const onChangeHandler = (id, value, optional = false) => {
    if (id === 'truckId') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        driverId: optional.driver,
        phoneNumber: optional.phoneNumber,
        trailerId: optional.trailerId,
      })
    } else if (id === 'isRepairTrailer') {
      if (value === false) {
        setMutationVariables({
          ...mutationVariables,
          [id]: value,
          trailerId: null,
          repairTrailerType: null,
          repairTrailerTypeOther: '',
        })
        setTrailerSelected({})
        setDisableTrailer(true)
        return
      }
      setDisableTrailer(false)
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    } else if (id === 'isRepairTruck') {
      if (value === false) {
        setMutationVariables({
          ...mutationVariables,
          repairTruckType: null,
          repairTruckTypeOther: '',
          [id]: value,
        })
      } else {
        setMutationVariables({
          ...mutationVariables,
          [id]: value,
        })
      }
    } else if (id === 'repairTruckType') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        repairTruckTypeOther: '',
      })
    } else if (id === 'repairTrailerType') {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        repairTrailerTypeOther: '',
      })
    } else if (_.includes(['isOutsource', 'outsourceType'], id)) {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        expense: 0,
        price: 0,
      })
    } else if (optional) {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
        [optional.id]: optional.value,
      })
    } else {
      setMutationVariables({
        ...mutationVariables,
        [id]: value,
      })
    }
  }
  return (
    <Div display='flex' flexDirection='column'>
      {/* ================== Data section ================== */}
      {
        isAddMode
          ? <Query
            query={GET_TRUCK_LIST_IN_REPAIR_SERVICE}
            variables={{ plateNumber: platenumberSearch }}
          >{(resp) => {
            if (resp.loading && _.isUndefined(resp.data.TruckList)) return <Loading />
            if (resp.error) return <P>เกิดข้อผิดพลาด</P>
            const platenumbers = resp.data.TruckList.lists.map(v => v.plateNumber)
            return (
              <Query
                query={DRIVER_LIST}
                variables={{ fullname: driverSearch }}
              >{(respDriver) => {
                if (respDriver.loading && _.isUndefined(respDriver.data.DriverList)) return <Loading />
                if (respDriver.error) return <P>เกิดข้อผิดพลาด</P>
                const drivers = respDriver.data.DriverList.lists.map(v => v.fullname)
                return (
                  <Div>
                    {
                      detailType(props.match.params, onChangeHandler, mutationVariables, {
                        platenumbers,
                        setPlatenumberSearch,
                        TruckList: resp.data.TruckList,
                        truckSelected,
                        setTruckSelected,
                        loading: resp.loading,
                        drivers,
                        setDriverSearch,
                        DriverList: respDriver.data.DriverList,
                        driverSelected,
                        setDriverSelected,
                        loadingDriver: respDriver.loading,
                        phoneNumber,
                        setPhoneNumber,
                      },
                      {
                        garageSearch,
                        garageSelected,
                        setGarageSearch,
                        setGarageSelected,
                      }, {
                        trailerPlatenumberSearch,
                        setTrailerPlatenumberSearch,
                        trailerSelected,
                        setTrailerSelected,
                        TrailerList: trailers,
                        setTrailers,
                        disableTrailer,
                        setDisableTrailer,
                      })
                    }
                    <Mutation
                      mutation={CREATE_REPAIR_JOB}
                    >{(doAction, { loading: mutationLoading }) => (
                      <ActionBar
                        loading={mutationLoading}
                        disabled={
                          _.isUndefined(mutationVariables.deadlineDate)
                          || _.isUndefined(mutationVariables.truckId)
                          || _.isUndefined(mutationVariables.currentFuel)
                          || _.isUndefined(mutationVariables.currentMile)
                          || (_.isUndefined(mutationVariables.warehouseId))
                          || (!mutationVariables.isRepairTruck && !mutationVariables.isRepairTrailer)
                          || (
                            mutationVariables.isOutsource
                            && (_.isUndefined(mutationVariables.outsourceType)
                              || (mutationVariables.outsourceType === 'SERVICECENTER'
                              && _.isUndefined(mutationVariables.garageId)))
                          ) || _.size(mutationVariables) === 0}
                        isAddMode={isAddMode}
                        isViewMode={isViewMode}
                        doAction={doAction}
                        mutationVariables={mutationVariables}
                        props={props}
                      />
                    )}
                    </Mutation>
                  </Div>
                )
              }}
              </Query>
            )
          }}
          </Query>
          : <Query
            query={GET_TRUCK_LIST}
            variables={{ plateNumber: platenumberSearch }}
          >{resp => (
            <Query
              query={GET_REPAIR_JOB_INFO}
              variables={{ id: props.match.params.id }}
            >{({
              data, error, loading, refetch,
            }) => {
              if ((loading && _.isEmpty(data)) || (resp.loading && _.isUndefined(resp.data.TruckList))) return <Loading center='true' />
              if (error || resp.error) return <P>เกิดข้อผิดพลาด</P>
              const platenumbers = resp.data.TruckList.lists.map(v => v.plateNumber)
              return (
                <Query
                query={DRIVER_LIST}
                variables={{ fullname: driverSearch }}
                >{(respDriver) => {
                  if (respDriver.loading && _.isUndefined(respDriver.data.DriverList)) return <Loading />
                  if (respDriver.error) return <P>เกิดข้อผิดพลาด</P>
                  const drivers = respDriver.data.DriverList.lists.map(v => v.fullname)
                  return (
                <Div>
                  {
                    detailType(props.match.params, onChangeHandler, mutationVariables, {
                      platenumbers,
                      setPlatenumberSearch,
                      TruckList: resp.data.TruckList,
                      truckSelected,
                      setTruckSelected,
                      loading: resp.loading,
                      drivers,
                      setDriverSearch,
                      DriverList: respDriver.data.DriverList,
                      driverSelected,
                      setDriverSelected,
                      loadingDriver: respDriver.loading,
                      phoneNumber,
                      setPhoneNumber,
                    },
                    {
                      garageSearch,
                      garageSelected,
                      setGarageSearch,
                      setGarageSelected,
                    }, {
                      trailerPlatenumberSearch,
                      setTrailerPlatenumberSearch,
                      trailerSelected,
                      setTrailerSelected,
                      TrailerList: trailers,
                      setTrailers,
                      disableTrailer,
                      setDisableTrailer,
                    }, data.RepairJobInfo)
                  }
                  { !_.isEmpty(data.RepairJobInfo.fuels)
                    && <Div display='flex' flexDirection='column'>
                      <H4 bold margin='40px 0 0'>ใบเบิกน้ำมัน</H4>
                      {_.map(data.RepairJobInfo.fuels, (v, index) => (
                      <Div display='flex' flexDirection='column'>
                        <Div margin='32px 0 0' display='flex' justifyContent='space-between' alignItems='center' width='87%'>
                          <P>{index + 1}.</P>
                          {
                            v.totalAmount === 1
                            && <KSButton
                              margin='0 0 0 0'
                              text='แก้ไขใบเบิกน้ำมัน'
                              icon='fas fa-edit'
                              disabled={_.includes(window.perms, PERMISSION.EDIT_REPAIR)}
                              onClick={() => {
                                setFuelOrder(v)
                                setEditFuelModal(true)
                              }}
                            />
                          }
                        </Div>
                      <FuelOrderRepairJob data={v} />
                      </Div>
                      ))}
                      </Div>
                  }
                  <EditFuelModal editFuelModal={editFuelModal} setEditFuelModal={setEditFuelModal} fuelOrder={fuelOrder} />
                  <Service info={data.RepairJobInfo} jobStatus={data.RepairJobInfo.status} setCloseJobModal={setCloseJobModal} refetch={refetch} jobId={props.match.params.id} services={data.RepairJobInfo.services} disabled={isAddMode || isViewMode} />
                  <Mutation
                    mutation={CLOSE_JOB}
                  >{(doCloseJob, { loading: doLoading }) => (
                    <Modal
                      title="ปิดใบแจ้งซ่อม"
                      visible={closeJobModal}
                      okButtonProps={{
                        loading: doLoading,
                        disabled: _.isUndefined(closeJobVariables.closeDate),
                      }}
                      cancelButtonProps={{ disabled: doLoading }}
                      okText='ปิดใบแจ้งซ่อม'
                      destroyOnClose={true}
                      onCancel={() => setCloseJobModal(false)}
                      onOk={() => {
                        setCloseJobVariables({})
                        doCloseJob({
                          variables: { ...closeJobVariables, id: data.RepairJobInfo.id },
                        }).then((res) => {
                          const response = res.data.CloseRepairJob
                          if (response.success) {
                            message.success(response.message)
                            refetch()
                          } else message.error(response.message)
                          setCloseJobModal(false)
                        })
                      }}
                    >
                      <Div display='flex' flexDirection='column'>
                        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' margin='0 0 8px 0'>
                          <P bold>วันที่ปิด</P>
                          <DatePicker onChange={e => setCloseJobVariables({ ...closeJobVariables, closeDate: e })} />
                        </Div>
                        <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' margin='0 0 8px 0'>
                          <P bold margin='0 0 8px 0'>เฝ้าระวัง</P>
                          <Checkbox onChange={e => setCloseJobVariables({ ...closeJobVariables, isWatching: e.target.checked })} />
                        </Div>
                        <P bold margin='0 0 8px 0'>หมายเหตุ</P>
                        <AntInput.TextArea defaultValue={data.RepairJobInfo.remark} onChange={e => setCloseJobVariables({ ...closeJobVariables, remark: e.target.value })} />
                        <P bold margin='16px 0'>รูปที่เกี่ยวข้อง</P>
                        <UploadWithModal
                          defaultFileList={_.size(data.RepairJobInfo.files) > 0 && data.RepairJobInfo.files.map(v => ({
                            name: v.filename,
                            url: v.url,
                            uid: v.url,
                          }))}
                          onChange={e => setCloseJobVariables({ ...closeJobVariables, files: e.fileList.map(v => v.originFileObj) })}
                          customRequest={() => null}
                          processData={false}
                          beforeUpload={() => false}
                          multiple={true}
                          listType='picture'
                        />
                      </Div>
                    </Modal>
                  )}
                  </Mutation>
                  {/* ================== Footer section ================== */}
                  {
                    !isViewMode
                      ? <Mutation
                        mutation={isAddMode ? CREATE_REPAIR_JOB : UPDATE_REPAIR_JOB}
                      >{(doAction, { loading: mutationLoading }) => (
                        <ActionBar
                          loading={mutationLoading}
                          disabled={
                            (!_.isUndefined(mutationVariables.deadlineDate) && _.isEmpty(mutationVariables.deadlineDate))
                            || (!_.isUndefined(mutationVariables.currentFuel) && !_.isNumber(mutationVariables.currentFuel))
                            || (!_.isUndefined(mutationVariables.currentMile) && !_.isNumber(mutationVariables.currentMile))
                            // || (!mutationVariables.isRepairTruck && !mutationVariables.isRepairTrailer)
                            || (
                              mutationVariables.isOutsource
                              && (
                                _.isEmpty(data.RepairJobInfo.outsourceType) && _.isEmpty(mutationVariables.outsourceType)
                                && _.isEmpty(data.RepairJobInfo.garageId) && _.isEmpty(mutationVariables.garageId)
                              )
                            )
                            || _.size(mutationVariables) === 0
                          }
                          isAddMode={isAddMode}
                          isViewMode={isViewMode}
                          doAction={doAction}
                          mutationVariables={mutationVariables}
                          props={props}
                          refetch={refetch}
                          status={data.RepairJobInfo.status}
                          services={data.RepairJobInfo.services}
                          setCloseJobModal={setCloseJobModal}
                        />
                      )}
                      </Mutation>
                      : <ActionBar
                        isAddMode={isAddMode}
                        isViewMode={isViewMode}
                        props={props}
                        status={data.RepairJobInfo.status}
                        services={data.RepairJobInfo.services}
                        setCloseJobModal={setCloseJobModal}
                        refetch={refetch}
                      />
                  }
                </Div>
                  )
                }}
            </Query>
              )
            }}
          </Query>
          )}
          </Query>
      }
    </Div>
  )
}

export default Index
export { Index }
